module.exports = __webpack_public_path__ + "static/img/tzActive.705c94f6.svg";